import type { LibraryItem as SDKLibraryItem } from '@speechifyinc/multiplatform-sdk';

export const parseAnalyticsProperties = (libraryItem: SDKLibraryItem) => {
  return libraryItem.analyticsProperties.keys().reduce(
    (acc, key) => ({
      ...acc,
      [key]: libraryItem.analyticsProperties.get(key)
    }),
    {}
  );
};
